import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { BiCheck } from "react-icons/bi";
import { AlertFillIcon } from '@primer/octicons-react';
import { useTranslation } from 'react-i18next';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import configInfo from '../config/config.json';
import TemplateListView    from "./TemplateListView";
import UserGroupAdminDetailsView from "./UserGroupAdminDetailsView";
import UserGroupAdminNewView     from "./UserGroupAdminNewView";


const UserGroupAdmin = () => {

  const { t }    = useTranslation(["common","custom"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "UserGroupAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'name',
      name: t("I18N_UGroup_name"),
      sortable: true,
      sortField: 'name',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_UGroup_name") + " (" + t("custom:I18N_Language_2") + ")",
      selector: row => row.nameLang2,
/* Sorting Chinese support for database is not reliable
      sortable: true,
      sortField: 'nameLang2',
*/
      grow: 2,
      omit: !configInfo.uiConfig.visibleFields.UGROUP_NameLang2
    },
    {
      name: t("I18N_UGroup_name") + " (" + t("custom:I18N_Language_3")+ ")",
      selector: row => row.nameLang3,
/* Sorting Chinese support for database is not reliable
      sortable: true,
      sortField: 'nameLang3',
*/
      grow: 2,
      wrap: true,
      omit: !configInfo.uiConfig.visibleFields.UGROUP_NameLang3
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Data_integrity"),
      cell: row => (
        !row.dataIntegrity ? <><span style={{color: 'red'}}><AlertFillIcon size={16} /></span>  <span style={{marginLeft:'5px', color: 'red'}}>{t("I18N_Integrity_check_failed")}</span></> :
                             <><span style={{color: 'green'}}><BiCheck size={16} /> </span>  <span style={{marginLeft:'5px', color: 'green'}}>{t("I18N_Integrity_check_success")}</span></>
      ),
      grow: 0.5,
      omit: !configInfo.appConfig.checkDataIntegrity
    },
    ...(configInfo.appConfig.isPrimaryIdentProvider ?
    [{
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }] : [])
  ];

  // ----- END - Data Table stuff -----

  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_IDENT_MGMT_API}
                                                  apiObjName={'usergroups'}
                                                  listPageTitle={t("I18N_UGroup_Mgmt")}
                                                  newObjTooltip={t("I18N_TIP_New_user_group")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_UGroup_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_usergroup")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'OrgAdminGeneralDeleteAccess'}
                                                  hideNewIcon={!configInfo.appConfig.isPrimaryIdentProvider}
                                                  hideDeleteIcon={!configInfo.appConfig.isPrimaryIdentProvider}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <UserGroupAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <UserGroupAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default UserGroupAdmin;
